import styled from 'styled-components';

const FilterListWrapper = styled.div((props) => {
  const { colours } = props.theme;

  return `
    min-height: 190px;
    height: 190px;
    padding: 0 4px;
    border-right: none;
    font-size: 14px;
    width: 250px;
    background-color: white;
    border: 1px solid ${colours.grey[400]};

    @media screen and (max-width: 1100px) {
      min-height: 180px;
      height: 180px;
    }
`;
});

const FilterWrapper = styled.div`
  padding: 10px;

  @media screen and (max-width: 1100px) {
    padding: 5px 10px;
  }
`;

const InputWrapper = styled.input((props) => {
  const { typography, palette } = props.theme;

  return ` 
        height: 30px;
        font-family: ${typography.family};
        font-size: 14px;
        padding-left: 4px;
        width: 97%;
        border-radius: 5px;
        outline: none;
        border: 1px solid #cfd2d4;
        color: ${palette.primary.dark};
    `;
});

export { FilterListWrapper, FilterWrapper, InputWrapper };



// WEBPACK FOOTER //
// ./components/filters/styled.js